import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import { Prop, Watch } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CheckoutSummary" })
export default class CheckoutSummary extends Vue {
    public localizer: any = Localizer;
    public summaryData: any = { termInfos: [], isCartDisabled: false };
    public validationErrors: any[] = [];
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public isGAEventSent: boolean = false;
    public paymentMethod: string = "PayPal";
    public formData: any = { isSalesTerms: false, productTermApprovals: [] };

    get routes() {
        return (<any>window).App.routes;
    }

    get cart() {
        return this.$store.getters["cartStore/cart"]
    }

    @Prop() readonly salesConditionsUrl: string;

    @Watch("cart") onCartChanged(value: any, oldValue: any) {
        this.paymentMethod = this.cart.paymentMethod ? this.cart.paymentMethod : "PayPal";
    }

    public async created() {
        this.isLoading = true;
        this.summaryData = (await Axios.post(this.routes.StoreCheckout_GetSummaryData)).data;
        if (this.summaryData.termInfos.length != 0) {
            for (const termInfo of this.summaryData.termInfos) {
                this.formData.productTermApprovals.push({ productCode: termInfo.productCode, isApproved: false });
            }
        }

        this.isLoading = false;
    }

    public getCart() {
        this.$store.dispatch("cartStore/getCart");
    }

    public async setCouponCode() {
        FormHelper.removeFocus();
        this.isLoadingForm = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.StoreCart_SetCouponCode, { couponCode: this.cart.coupon.code });

            this.getCart();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
        this.isLoadingForm = false;
    }

    public async setPaymentMethod() {
        FormHelper.removeFocus();
        this.isLoadingForm = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.StoreCart_SetPaymentMethod, { paymentMethod: this.paymentMethod });

            this.getCart();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
        this.isLoadingForm = false;
    }

    public async placeOrder() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        try {
            let result = (await Axios.post(this.routes.StoreCheckout_Summary, this.formData)).data;

            (<any>window).location = result.redirectUrl;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public updated() {
        this.$nextTick(function () {
            if (this.cart && !this.isGAEventSent) {
                var itemList = [];

                for (var computedCartRow in this.cart.computedCartRows) {
                    itemList.push({
                        item_id: this.cart.computedCartRows[computedCartRow].product.orderCode,
                        item_name: this.cart.computedCartRows[computedCartRow].product.title,
                        affiliation: "Beghelli",
                        currency: "EUR",
                        item_category: this.cart.computedCartRows[computedCartRow].product.categoryName,
                        price: this.cart.computedCartRows[computedCartRow].unitPrice,
                        quantity: this.cart.computedCartRows[computedCartRow].cartRow.quantity
                    });
                }

                GTagHelper.sendCustomEvent("begin_checkout", {
                    currency: "EUR",
                    value: this.cart.totalWithCostsPrice,
                    coupon: this.cart.coupon.code,
                    items: itemList
                });

                this.isGAEventSent = true;
            }
        });
    }

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data);
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};